export default __webpack_public_path__ + "static/media/HeroImg.bd68b38f.png";